<div [ngStyle]="{ 'display' : this.proceduresFilterController.active? 'block' : 'none'}" [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">
  <div class="loading" [ngClass]="this.proceduresFilterController.loading? 'active' : ''">
    <div></div>
  </div>
  <form autocomplete="off"
    id="ngForm1"
    [ngClass]="[this.proceduresFilterController.active ? 'active' : '',  tabsService.fullScreenMode ? 'fullscreen' : '']"
    name="ngForm1"
    #ngForm1="ngForm"
    id="proceduresPrimaryForm"
    style="height: 600px"
  >

  <div class="fields__block">
    <div class="fields__block__section">
      <div class="table-fields">
        <div>
          <div class="btn">
            <button type="submit" (click)="selectAll()" >Select All</button>
            <button type="submit" (click)="deselectAll()" >Deselect All</button>
          </div>
          <div class="scrollable">
            <table>
              <thead>
                <tr>
                  <th></th>
                  <th>Name</th>
                  <th scope="col">Id</th>
                  <th scope="col">Type</th>
                  <th scope="col">Airport</th>
                  <th scope="col">On Map</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let proc of procedureController.procedures; let i = index" [class.highlighted]="proc.isselected">
                  <td><input type="checkbox" id="procedureCheckbox_{{i}}" name="procedureCheckbox_{{i}}" [(ngModel)]="proc.isselected"/></td>
                  <td>{{ proc.name }}</td>
                  <td>{{ proc.procedureid }}</td>
                  <td>{{ proc.proceduretype }}</td>
                  <td>{{ proc.airport }}</td>
                  <td>{{ proc.mapstatus }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="btn">
            <button type="submit" (click)="addToMap()">Add To Map</button>
            <button type="submit" (click)="removeFromMap()">Remove From Map</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</form>

</div>
